import type { Axios, InternalAxiosRequestConfig } from 'axios'

let blocksMutations = false

const BLOCKED_METHODS = new Set(['put', 'patch', 'delete'])

export function setAccessPreviewMutationGuard(enabled: boolean): void {
  blocksMutations = enabled
}

export function shouldBlockAccessPreviewMutation(
  method: string | undefined
): boolean {
  if (!blocksMutations || !method) return false
  return BLOCKED_METHODS.has(method.toLowerCase())
}

export function attachAccessPreviewMutationGuard(client: Axios): void {
  client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (shouldBlockAccessPreviewMutation(config.method)) {
      return Promise.reject(new Error('View-as overlay cannot change data'))
    }
    return config
  })
}
